
export const UpgradeNames = {
  CREDITS_PER_PUZZLE: 'Upgrade Credits Per Puzzle Solved',
  CREDITS_PER_POSSIBILITY: 'Upgrade Credits Per Possibility Eliminated',
  CREDITS_PER_CELL: 'Upgrade Credits Per Cell Solved'
}

export const SolverNames = {
  BOX_SOLVER: 'Box Solver',
  COL_SOLVER: 'Column Solver',
  ROW_SOLVER: 'Row Solver'
}

export const Challenges = [{
  name: 'Destroyer',
  rules: [{
    reward: 1.1,
    unlock: 2,
    complete: 2,
    destroyers: 1
  }, {
    reward: 1.2,
    unlock: 5,
    complete: 3,
    destroyers: 2
  }, {
    reward: 1.3,
    unlock: 25,
    complete: 10,
    destroyers: 3
  }]
}, {
  name: 'No Click',
  rules: [{
    reward: 1.2,
    unlock: 2,
    complete: 4,
    noClicks: 1
  }]
}, {
  name: 'Auto Blackout',
  rules: [{
    reward: 1.5,
    unlock: 5,
    complete: 3,
    noAuto: 1
  }]
}, {
  name: 'Rotate',
  rules: [{
    reward: 1.7,
    unlock: 7,
    complete: 4,
    rotate: 10000
  }]
}]

export const StrategyType = {
  // Picks totally at random
  RANDOM: 'Random',
  // Picks the smallest choice first
  TARGETED: 'Targeted',
  // Waits until there is a 50/50
  PATIENT: 'Patient'
}
